import store from '@/store/store';
import { SET_DEMANDES_EN_ATTENTES } from '@/store/modules/logistique/suiviProduction-mutation-type';
import { UpdateEtatDemandeSuiviProduction } from '@/services/logistique/suiviProduction/actionSuiviProduction';
import {
  ETAT_A_EXPEDIER,
  ETAT_EN_COURS,
  ETAT_REALISE,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { ETAT_VALIDE } from '@/configuration/logistique/intervention/interventionConf';

function shiftFirstsDemandesInKeyDico(dicoDemandesParLigneCommandeId, ligneCommandeId) {
  const demandes = dicoDemandesParLigneCommandeId?.[ligneCommandeId] || [];
  if (demandes.length === 0) return [];
  const firtOrderDemande = Math.min(...demandes.map((demande) => demande.ordre));
  const result = demandes.filter((demande) => demande.ordre === firtOrderDemande);
  dicoDemandesParLigneCommandeId[ligneCommandeId] = demandes
    .filter((demande) => demande.ordre !== firtOrderDemande);
  return result;
}

export function gestionDemandesEnAttente(demandes) {
  const demandesCommandeATraiter = demandes
    .filter(demande => ![ETAT_EN_COURS, ETAT_REALISE].includes(demande.ot?.otEtat))
    .filter((demande) => demande.ordre === 0 || !!demande.ordre);
  if (demandesCommandeATraiter.length === 0) return demandes;

  demandesCommandeATraiter.sort((a, b) => a.ordre - b.ordre);

  const dicoDemandesParLigneCommandeId = demandesCommandeATraiter.reduce((acc, demande) => {
    if (!acc[demande.ligneCommandeId]) acc[demande.ligneCommandeId] = [];
    acc[demande.ligneCommandeId].push(demande);
    return acc;
  }, {});

  Object.keys(dicoDemandesParLigneCommandeId).forEach((ligneId) => {
    shiftFirstsDemandesInKeyDico(dicoDemandesParLigneCommandeId, ligneId);
  });

  store.commit(`suiviProduction/${SET_DEMANDES_EN_ATTENTES}`, dicoDemandesParLigneCommandeId);

  const demandeEnAttenteIds = Object.values(dicoDemandesParLigneCommandeId).reduce((acc, val) => {
    acc.push(...val.map((demande) => demande.id));
    return acc;
  }, []);
  const demandesFilter = demandes.filter(d => !demandeEnAttenteIds.includes(d.id));
  return demandesFilter;
}

export function shiftFirstsDemandesEnAttente(ligneCommandeId) {
  if (!ligneCommandeId) return [];
  const dicoDemandesParLigneCommandeId = store.getters['suiviProduction/demandesEnAttentes'];
  return shiftFirstsDemandesInKeyDico(dicoDemandesParLigneCommandeId, ligneCommandeId);
}

export async function gestionDemandesDePoseDispositif(demandes) {
  if (!demandes || demandes.length === 0) return [];
  const promises = demandes.map(demande => UpdateEtatDemandeSuiviProduction(
    demande,
    ETAT_VALIDE,
    ETAT_A_EXPEDIER,
  ));
  const newDemandes = await Promise.all(promises);
  return newDemandes;
}
